import { fetchFutures } from '../api/api';
import { useQuery} from 'react-query'
import RouteUtils from '../utils/routeUtils'
import { useState, useEffect } from 'react';
import { FuturesSlugsShort } from '../utils/gameUtils';

export const useFuturesQuery = (league) => {
    const [enabled, setEnabled] = useState(true);
    const leagueFilter = RouteUtils.getLeague(league);
    const { isLoading, data, isError } = useQuery([league], () => fetchFutures(leagueFilter), {enabled, retry: false});
    const [futures, setFutures] = useState([]);

    useEffect(() => {
        if (data && data.length) {
            setFutures(data.map(d => {
                return {
                    ...d,
                    short: FuturesSlugsShort[d.slug],
                }
            }));
            setEnabled(false);
        }
    }, [data, isLoading]);

    return { isLoading, futures, isError };
}